import { atom } from "recoil";

export const promoBannersEditModalStore = atom({
	key: "promoBannersEditModalStore",
	default: {
		show: false,
		loaded: false,
		image: "",
		currentOption: {
			nameType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			descriptionType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
		},
		nameType: "",
		name: "",
		description: "",
		descriptionType: "",
		descriptionPrefix: "",
		gameID: "",
		minDeposit: "",
		limit: "",
		wager: "",
		from: "",
		to: "",
		type: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
